export default {
  message: {
    textAlign: 'center'
  }
};